
  import Vue from 'vue'
  import Component from 'vue-class-component';
  import {Prop} from 'vue-property-decorator';

  @Component({})
  export default class ListScaffold extends Vue {
    @Prop({required: false, default: false}) loading!: boolean;
    @Prop({required: true}) items!: any[];
    @Prop({required: false, default: 'center'}) align!: 'center' | 'start' | 'end' | 'space-around' | 'space-between';
    @Prop({required: false, default: 'center'}) justify!: 'center' | 'start' | 'end' | 'space-around' | 'space-between';
    @Prop({required: false, default: 12}) cols!: number;
    @Prop({required: false, default: 6}) sm!: number;
    @Prop({required: false, default: 4}) md!: number;
    @Prop({required: false, default: 3}) xl!: number;
    @Prop({required: false}) emptyMessage!: string;
  }
